import { styled } from 'styled-components';

import { buttonIconWrapperDistanceVar } from 'components/Button/Button.styled';

export const CmsReactionsContainer = styled.div`
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 18%);
`;

export const CmsReactionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 70px;
  padding: 32px 20px;
`;

export const CmsReactionsSummaryContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
`;

export const CmsReactionsUserEngagementBar = styled.div`
  display: flex;
  gap: 28px;
`;

export const CmsReactionsButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  ${buttonIconWrapperDistanceVar}: 10px;
`;
